import axios from 'axios';

export default defineNuxtPlugin({
    name: 'http',
    dependsOn: ['alerts', 'auth', 'axios', 'i18n'],
    async setup(nuxtApp)
    {
        const { $alert, $auth } = useNuxtApp();

        axios.interceptors.request.use((config) =>
        {
            const url = new URL(`${config.baseURL}/${config.url}`);

            config.headers['Request-Token'] = requestToken(url.pathname, $auth.token());

            // if ($auth.token())
            //     config.headers.Authorization = `Bearer ${$auth.token()}`;

            if ($auth.impersonating())
                config.headers['Access-Impersonate'] = $auth.impersonatingValue();

            return config;
        });
        axios.interceptors.response.use(
            response => response,
            (error) =>
            {
                const ex = {
                    code: 500,
                    message: 'Unexpected exception occured.',
                    data: null as any,
                    inner: error,
                    handled: false
                };

                if (error.response)
                {
                    ex.code = error.response.status;
                    ex.data = (typeof error.response.data === 'string') ? { message: error.response.data } : error.response.data || {};
                    ex.message = 'message' in ex.data ? ex.data.message : error.message;
                }
                else
                {
                    ex.message = error.message;
                }

                if (ex.code >= 400)
                {
                    switch (ex.code)
                    {
                        /* 401 - Unauthorized */
                        case 401:
                        {
                            if (!error.config.url.startsWith('auth/'))
                                $auth.logout();

                            break;
                        }
                        /* 403 - Forbidden */
                        case 403:
                        {
                            setTimeout(() =>
                            {
                                if (!ex.handled)
                                {
                                    const message = $t('[[[Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.]]]');
                                    const duration = 1000 * 3600 * 24;

                                    $alert.warning(message, { dismissible: false, important: true, duration, action: { label: $t('[[[Odśwież]]]'), onClick: () => location.reload() } });
                                }
                            },
                            100);

                            break;
                        }
                        /* 404 - Not Found */
                        case 404:
                        {
                            setTimeout(() =>
                            {
                                if (!ex.handled)
                                {
                                    $alert.debounceError($t('[[[Błąd 404. Nie znaleziono żądanego zasobu.]]]'));
                                }
                            },
                            100);

                            break;
                        }
                        /* 500 - Internal Server Error
                           503 - Service Unavailable */
                        case 500:
                        case 503:
                        {
                            if (error.message && error.message == 'Network Error')
                                $alert.debounceDanger($t('[[[Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.]]]'));
                            else
                                $alert.debounceDanger($t('[[[Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.]]]'));

                            if (ex.data && ex.data.stackTrace)
                            {
                                // eslint-disable-next-line no-console
                                console.log(ex.data.message);
                                // eslint-disable-next-line no-console
                                console.log(ex.data.stackTrace);
                            }

                            break;
                        }
                        default:
                        {
                            if (ex.code > 500)
                                $alert.debounceError($t('[[[Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.]]]'));

                            break;
                        }
                    }
                }

                return Promise.reject(ex);
            }
        );
    }
});
